import React from 'react';
import styled, { TC } from '@benzinga/themetron';
import { BaseQuote } from '@benzinga/advanced-news-manager';
import { Quote } from '@benzinga/quotes-manager';
import { PerformanceColor } from '../../Ticker/PerformanceColor';

interface ChangeSincePublishModuleProps {
  currentPrice: Quote['currentPriceFormatted'];
  storyPrice: BaseQuote['price'];
}

export const ChangeSincePublishModule: React.FC<ChangeSincePublishModuleProps> = props => {
  let storyPercent = 0;
  let storyNominal = 0;

  if (props.storyPrice) {
    const publishQuotePrice = Number(props.storyPrice);
    storyNominal = Math.round((Number(props.currentPrice) - publishQuotePrice) * 100) / 100;
    storyPercent = (storyNominal / publishQuotePrice) * 100 || 0;
  }

  return (
    <ChangeSincePublishedContainerRow>
      <DescriptionTextDiv>Change Since Publish</DescriptionTextDiv>

      <ChangeSincePublishedInnerRow>
        <PerformanceColorPaddingDiv>
          <PerformanceColor hasArrow stat={storyNominal} />
        </PerformanceColorPaddingDiv>{' '}
        <PerformanceColorPaddingDiv>
          <PerformanceColor isPercentage stat={storyPercent} />
        </PerformanceColorPaddingDiv>
      </ChangeSincePublishedInnerRow>
    </ChangeSincePublishedContainerRow>
  );
};

const ChangeSincePublishedInnerRow = styled(TC.Row)`
  flex-grow: 1;
  font-size: 0.875em;
  justify-content: center;
`;

const ChangeSincePublishedContainerRow = styled(TC.Row)`
  font-size: 1em;
  padding: 5px 10px;
`;

const PerformanceColorPaddingDiv = styled.div`
  padding-right: 0.25em;
`;

const DescriptionTextDiv = styled(TC.Div)`
  color: ${props => props.theme.colors.foregroundInactive};
  font-size: 0.75em;
  font-weight: 300;
  white-space: nowrap;
`;
